var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('p',{attrs:{"id":"errorText"}},[_vm._v("O-o-oh! You don't have access to this.")]),_vm._v(" "),_c('a',{attrs:{"id":"errorLink","href":_vm.$Fabric.getFabricSystemRoles().includes(_vm.$auth.user().role) ? '/fabric/dashboard' : '/shirt/dashboard'}},[_vm._v("Go Back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }